var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgPlus = function SvgPlus(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "currentColor",
    viewBox: "0 0 12 12"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M5 11.7a.3.3 0 0 0 .3.3h1.4a.3.3 0 0 0 .3-.3V7h4.7a.3.3 0 0 0 .3-.3V5.3a.3.3 0 0 0-.3-.3H7V.3a.3.3 0 0 0-.3-.3H5.3a.3.3 0 0 0-.3.3V5H.3a.3.3 0 0 0-.3.3v1.4a.3.3 0 0 0 .3.3H5z"
  })));
};
export default SvgPlus;